import { useContext, createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import * as PusherPushNotifications from "@pusher/push-notifications-web";
import { axiosInstance } from "../../helpers/axiosInstance";
import axios from "axios";

/*
El URL

https://api.fiducia.com.mx/

Cambia a

http://backup.fiducia.com.mx:8080/raptor/

*/

const AuthContext = createContext(undefined);
export default function AuthProvider({ children }){
  const [token, setToken] = useState(sessionStorage.getItem("token") ?? "");
  const [user, setUser] = useState(JSON.parse(sessionStorage.getItem("user")) ?? null);
    const [errorApi, setErrorApi] = useState({
        show : false,
        error : "",
        message : ""
    });
  const navigate = useNavigate();
  axiosInstance.defaults.headers.common['X-Fd-Auth-Token'] = token ?? JSON.parse(sessionStorage.getItem('token'));
  //axiosInstance.defaults.withCredentials = true;

   function cleanData(){
       setUser(null);
       setToken("");
       sessionStorage.clear();
       localStorage.clear();
       setErrorApi({
           show : false,
           error : "",
           message: ""
       });
   }
  // const beamsClient = new PusherPushNotifications.Client({
  //   instanceId: '2f3a5759-eee8-497a-bc9d-44b643536e46',
  // });

  // const tokenProvider = new PusherPushNotifications.TokenProvider({
  //   url: "http://localhost:8080/pusher/beams-auth/",
  // })

  // Token, se ejecuta cada que hay un cambio en la interfaz
  //para verifcar que la sesión este activa
  useEffect(() => {
      const tokenLS = !!sessionStorage.getItem('token');

      if (tokenLS){
          axiosInstance.post( '/ping')
              .then(res => {
                  if (res.status === 200){
                      sessionStorage.setItem("token",  token);
                      setToken(token);
                  }
              }).catch((error) => {
              navigate("/");
              console.error(error);
              cleanData();
          })
      }

  },[token, navigate]);

  //Iniciar sesión

  function loginAction(usuario, password){
    axios.post(process.env.REACT_APP_API_URL + '/signin' ,{ usuario, password }, { //'https://backup.fiducia.com.mx/api/'
        headers: {
          "Content-Type" : "application/json",
        },
        //withCredentials : true
      }).then(res => {
        if (res.data.authToken) {
            // Actualizar token
            /**
             * @param res respuesta del servidor
             * @param res.data.authToken token de la sesión
             * @param res.data.acl permisos de usuario
             * */

            const authT = res.data.authToken.replace(/['"]+/g, '');

            setToken(authT);
            sessionStorage.setItem("token",  JSON.stringify(authT));
            setUser(res.data);
            // Guadar los datos en localstorage por si se refresca la página
            /////// Nota para mi: useMemo() tal vez pueda servir//////
            sessionStorage.setItem("user",  JSON.stringify(res.data));
            // Hacer un objeto con el acl y el usuario de la sesión
            sessionStorage.setItem("acl", JSON.stringify(res.data.acl));
            navigate("/contrato/clientes");

            setErrorApi({
                show : false,
                error : "",
                message : ""
            });

            ////////////// Notificaciones //////////////////////

            ////////////////// Notificaciones a un solo usuario /////////////
            // const userId =  res.data.response.identity.usuario.id_usuario.toString();
            //
            //  beamsClient.start()
            //      .then(() => beamsClient.setUserId(userId, tokenProvider))
            //      .then(() => console.log("UserId Registrado"))
            //      .catch(e => console.error('Error', e));
            //
            //  beamsClient.start().then(() => console.log("start")).catch(console.error);

            ///////////// Notificaciones generales ///////////
            // beamsClient.start()
            //     .then(() => beamsClient.addDeviceInterest("7912"))
            //     .then(() => beamsClient.getDeviceInterests())
            //     .then((interests) => console.log("Current interests:", interests))
            //     .catch(console.error);

            // return;
        } else {
            setErrorApi({
                show: true,
                error: "Hubo un error",
                message: "No se pudo procesar la solicitud, intente más tarde",
            })
        }
    }).catch (err => {
        // console.error(err);
        setErrorApi({
            errorApi,
            show: true,
            error: err.response.data.errors[0].message,
            message: err.response.data.errors[0].details,
        })
    })
  }

  //Cerrar sesión, hace la peticion, se elimina todo el localstorage y detiene las notificaciones
  function logOut(){
    //////// borrar el estado del SDK y lo deja en un estado de inicio vacio.
    // beamsClient.clearAllState()
    //     .then(() => console.log('Notificaciones desacivadas'))
    //     .catch(e => console.error('Error: ', e));
      axiosInstance.post('/signout')
      .then(() => {
          navigate("/");
          cleanData();
      }).catch((error) => {
          navigate("/");
          cleanData();
          console.log(error);
      });
  }

  return (
    <AuthContext.Provider value={{ token, user, loginAction, logOut, errorApi }}>
      {children}
    </AuthContext.Provider>
  );

};

export const useAuth = () => {
  return useContext(AuthContext);
};
